













































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import DoorPeriod from "./door_period.vue";

@Component({
  components: {
    DoorPeriod,
  },
})
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;

  formData: any = {};

  doorPeriodModalVisible: boolean = false;

  showPeriodModal() {
    this.doorPeriodModalVisible = true;
  }

  hidePeriodModal() {
    this.doorPeriodModalVisible = false;
  }

  renderCommand(command: string): string {
    switch (command) {
      case "keep_open_period":
        return `更长时间常开门${this.formData.start_hour}-${this.formData.end_hour}`;
      case "keep_open":
        return "20分钟常开门";
      case "open":
        return "短开门";
      case "close":
        return "关门";
      default:
        return "-";
    }
  }

  async mounted() {
    const res = await this.$store.dispatch("stadium/getControlPeriod", {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
  }

  setControl(str: string) {
    if (str === "keepopen") {
      this.showTsConfirm({
        title: "确认信息",
        content: "确认要常开吗？",
        onOk: async () => {
          const res = await this.$store.dispatch("stadium/setControlKeep", {
            stadium_id: this.stadiumId,
          });
          if (res && res.Message === "success") {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        },
      });
    } else if (str === "open") {
      this.showTsConfirm({
        title: "确认信息",
        content: "确认要普通开吗？",
        onOk: async () => {
          const res = await this.$store.dispatch("stadium/setControlOpen", {
            stadium_id: this.stadiumId,
          });
          if (res && res.Message === "success") {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        },
      });
    } else if (str === "close") {
      this.showTsConfirm({
        title: "确认信息",
        content: "确认要关闭吗？",
        onOk: async () => {
          const res = await this.$store.dispatch("stadium/setControlClose", {
            stadium_id: this.stadiumId,
          });
          if (res && res.Message === "success") {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        },
      });
    }
  }
}
